import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CoreServiceRegistry } from '../../../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../../../shared/shared-service-registry';




@Component({
  selector: 'lfwms-img-viewer-popup',
  templateUrl: './full-view-img-viewer.component.html',
  styleUrls: ['./full-view-img-viewer.component.css']
})
export class FullViewImgViewerPopupComponent {

  @Input() public currentImgUrl: string = '';
  @Input() public imgUrlArray: Array<any> = [];
  @Input() public index: number = 0;
  @Input() public storerKey: string = '';
  @Input() public receiptKey: string = '';
  @Input() public showOptions: boolean = false;
  @Output() public nextOrPreviousImage = new EventEmitter();
  @Output() public xButtonClicked = new EventEmitter();
  @Output() public deleteImage = new EventEmitter();
  @Output() public downloadImage = new EventEmitter();
  public lblPreview: string = '';
  public lblNext: string = '';
  public lblOptions: string = '';
  public lblDownload: string = '';
  public lblDelete: string = '';
  public resourceService: any;
  public showOptionsDropdown: boolean = false;
  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
      this.resourceService = this.coreServiceRegistry.resourceService;
      this.lblPreview = this.resourceService.get('sku_lbl_prev');
      this.lblNext = this.resourceService.get('sku_lbl_next');
      this.lblOptions = this.resourceService.get('sku_lbl_options');
      this.lblDownload = this.resourceService.get('sku_lbl_download');
      this.lblDelete = this.resourceService.get('sku_lbl_delete');
     }

  /**
   * navigate To Next Or Previous Image
   */
  public navigateToNextOrPreviousImage(prevOrNext: string) {
    const navigationDirection = prevOrNext;
    this.nextOrPreviousImage.emit(navigationDirection);

  }

  /**
   * close Image Viewer
   */
  public closeImageViewer() {
    this.xButtonClicked.emit();
  }

  /**
   * Toggle options dropdown
   */
  public toggleOptionsDropdown() {
    this.showOptionsDropdown = !this.showOptionsDropdown;
  }

  /**
   * Handle download click
   */
  public onDownloadClick() {
    this.showOptionsDropdown = false;
    this.downloadImage.emit(this.index);
  }

  /**
   * Handle delete click
   */
  public onDeleteClick() {
    this.showOptionsDropdown = false;
    this.deleteImage.emit(this.index);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/setup/customer/commodity/commodity-skuImage-accordian/full-view-img-viewer/full-view-img-viewer.component.ts